import AIDialog from '../commons/ai-dialog';
import { createElement } from 'react';
import { useState } from 'react';
import './style.less';
function CardLink(props) {
    const { answer, pageData = {}, onComplete } = props;
    const [showLink, setShowLink] = useState(false);
    const handleComplete = () => {
        setShowLink(true);
        onComplete?.();
    };
    const handleClick = () => {
        const { pageTitle, id, ...extraParams } = pageData;
        console.log('handleClick///');
    };
    return (createElement("div", { className: "card-link" },
        createElement(AIDialog, { type: "text", text: answer, onComplete: handleComplete }),
        showLink && pageData?.pageTitle ? (createElement("p", { className: "card-link-a" },
            createElement("a", { onClick: handleClick, role: "link", "aria-label": pageData?.pageTitle, tabIndex: "0" }, pageData?.pageTitle))) : null));
}
export default CardLink;
